import {
  getLookupDataSuccess,
  getLookupDataError,
  getLookupTableData,
  getLookupTableDataSuccess,
  getLookupTableDataError
} from '../../actions/profile/lookupData'
import { setErrors } from '../../actions/shared/shared'
import axios from 'axios'
import { AxiosResponse } from 'axios'
import { hostUrl } from '../../config/config'

const getData = table => {
  const url = `${hostUrl}/GetLookupData.ashx?table=${table}`
  return axios.post(url, {}, { withCredentials: true })
}

function status(response: AxiosResponse) {
  if (response.status >= 200 && response.status < 300) {
    return Promise.resolve(response)
  } else {
    return Promise.reject(new Error(response.statusText))
  }
}

function json(response: AxiosResponse) {
  return response.data
}

const getLookupData = tables => {
  return function(dispatch) {
    return Promise.all(
      tables.map(table => {
        dispatch(getLookupTableData(table))
        return getData(table)
          .then(status)
          .then(json)
          .then(data => {
            if (data.hasOwnProperty('data')) {
              return dispatch(
                getLookupTableDataSuccess({
                  table,
                  data: data.data
                })
              )
            } else {
              throw new Error('No data was returned by the service')
            }
          })
          .catch(error => {
            dispatch(
              getLookupTableDataError({
                table,
                error
              })
            )
            dispatch(getLookupDataError())
            dispatch(
              setErrors([
                'There was a problem requesting data from server. Please try again. If problem persists, please contact CDHA.'
              ])
            )
          })
      })
    ).then(dispatch(getLookupDataSuccess()))
  }
}

export default getLookupData
